import { SxProps } from '@mui/joy/styles/types'
import React from 'react'

type Props = {
  isPaperExist?: boolean,
  isVideoExist?: boolean,
}

const useStyleCardExplanation = ({
  isPaperExist,
  isVideoExist,
}: Props) => {
  return {
    main: { display: 'grid', gridTemplateColumns: isPaperExist && isVideoExist ? '1fr 2fr' : '1fr', gap: 2, overflow: 'auto' },
    listPapers: {
      display: "grid",
      height: "fit-content",
      gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
      gridTemplateRows: "min-content"
    },
    paper: {
      borderRadius: 8,
      boxShadow: `0px 4px 4px #ddd`,
      display: 'grid',
      m: 1,
      boxSizing: "border-box",
      width: "fit-content",
      justifyContent: "center",
      justifyItems: "center",
      textAlign: "center",
      maxWidth: '200px',
      transition: 'all 0.5s',
      backgroundColor: '#f6f6f6',
      py: 3,
      '&:hover': {
        backgroundColor: '#edecec',
      }
    },
    paperIcon: {
      fontSize: 100,
      color: "#3b6ced",
    }
  }
}

export default useStyleCardExplanation